import { render, staticRenderFns } from "./TreeCore.vue?vue&type=template&id=27902840&scoped=true&"
import script from "./TreeCore.vue?vue&type=script&lang=js&"
export * from "./TreeCore.vue?vue&type=script&lang=js&"
import style0 from "./TreeCore.vue?vue&type=style&index=0&id=27902840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27902840",
  null
  
)

export default component.exports